<template>
  <div>
    <div class="news-main">
        <div class="news-contents-main">
          <div class="all">
        <div class="news-title wow animate__fadeInLeft">
          <div class="news-one">新闻资讯</div>
          <div class="news-two">INFORMATION</div>
        </div>
        <!-- <div
        class="news-all-title wow animate__fadeInRight"
        v-for="(item, index) in newsList"
        :key="index"
        :class="{ newsactive: NewsIndex === index }"
        @click="changeNews(index)"
      >
        <div class="news-every wow animate__zoomIn">{{ item.headline }}</div>
      </div> -->
      </div>
      <div class="news-content-main">
        <!-- 新闻资讯左侧 -->
        <div class="news-content-main-left wow animate__fadeInLeft">
          <div class="content-left">
            <div class="left-img">
              <img src="../../../../assets/newsone.png" alt="" />
            </div>
            <div class="content-left-title">
              “水井坊”最强乒团·2022中国，最美大国
            </div>
            <div class="content-left-main">
              奇点智播为本项赛事提供了全方位的信号制作服务与传输保障，特别地打造了全远程转播制作新模式，实现了高效、轻量化的现场部署...
            </div>
            <div class="content-left-time">2023-04-10</div>
          </div>
          <div class="content-left">
            <div class="left-img">
              <img src="../../../../assets/newstwo.png" alt="" />
            </div>
            <div class="content-left-title">北京体育大学演播助训小程序</div>
            <div class="content-left-main">
              北京体育大学演播助训小程序是由北京奇点智播科技有限公司研发的一款面向专业运动训练与教学场景，为教练员和运动员提供观看训...
            </div>
            <div class="content-left-time">2023-03-10</div>
          </div>
        </div>
        <!-- 新闻资讯右侧 -->
        <div class="news-right-main wow animate__fadeInRight">
          <div class="news-right-one">
            <div class="time">
              <span class="time-year">2023</span>
              <span class="time-mouth">03-10</span>
            </div>
            <div class="time-serve">
              <div class="time-title">陈露国际冰场【智慧冰场】服务</div>
              <div class="time-title-two">
                奇点智播【智慧冰场】服务方案在冰场建立多角度多区域的视频数据采集摄像头，在平时教学训练过程中，采集收录学员的花样滑冰动作...
              </div>
            </div>
          </div>
          <div class="news-right-two">
            <div class="time">
              <span class="time-year">2023</span>
              <span class="time-mouth">03-10</span>
            </div>
            <div class="time-serve">
              <div class="time-title">
                基于有线电视网的8K足球赛事端到端转播方案研究与试验测试
              </div>
              <div class="time-title-two">
                2022年9月，《基于有线电视网的8K足球赛事端到端转播方案研究与试验测试》征入国家广播电视总局、工业和信息化部的超高清视频典型应用案例名单
              </div>
            </div>
          </div>
          <div class="news-right-three">
            <div class="time">
              <span class="time-year">2023</span>
              <span class="time-mouth">03-10</span>
            </div>
            <div class="time-serve">
              <div class="time-title">
                基于有线电视网的8K足球赛事端到端转播方案研究与试验测试
              </div>
              <div class="time-title-two">
                2022年9月，《基于有线电视网的8K足球赛事端到端转播方案研究与试验测试》征入国家广播电视总局、工业和信息化部的超高清视频典型应用案例名
              </div>
            </div>
          </div>
        </div>
      </div>
        </div>
    </div>
  </div>
</template>
<script>
import newsOne from "../../../../assets/newsone.png";
import newsTwo from "../../../../assets/newstwo.png";
export default {
  data() {
    return {
      NewsIndex: 0, //成功案例选中的tab
      //新闻资讯
      newsList: [
        {
          headline: "全部",
          children: [
            {
              coverImage: newsOne,
              msg: " “水井坊”最强乒团·2022中国，最美大国",
              recommend:
                " 奇点智播为本项赛事提供了全方位的信号制作服务与传输保障，特别地打造了全远程转播制作新模式，实现了高效、轻量化的现场部署..."
            },
            {
              coverImage: newsTwo,
              msg: " “水井坊”最强乒团·2022中国，最美大国",
              recommend:
                " 奇点智播为本项赛事提供了全方位的信号制作服务与传输保障，特别地打造了全远程转播制作新模式，实现了高效、轻量化的现场部署..."
            },
            {
              year: "2023",
              mouth: "03-10",
              title: "陈露国际冰场【智慧冰场】服务",
              introduction:
                "奇点智播【智慧冰场】服务方案在冰场建立多角度多区域的视频数据采集摄像头，在平时教学训练过程中，采集收录学员的花样滑冰动作..."
            },
            {
              year: "2023",
              mouth: "03-10",
              title: " 基于有线电视网的8K足球赛事端到端转播方案研究与试验测试",
              introduction:
                "2022年9月，《基于有线电视网的8K足球赛事端到端转播方案研究与试验测试》征入国家广播电视总局、工业和信息化部的超高清视频典型应用案例名单"
            },
            {
              year: "2023",
              mouth: "03-10",
              title: "基于有线电视网的8K足球赛事端到端转播方案研究与试验测试",
              introduction:
                "2022年9月，《基于有线电视网的8K足球赛事端到端转播方案研究与试验测试》征入国家广播电视总局、工业和信息化部的超高清视频典型应用案例名"
            }
          ]
        },
        {
          headline: "行业资讯",
          children: [
            {
              coverImage: newsOne,
              msg: " “水井坊”最强乒团·2022中国，最美大国",
              recommend:
                " 奇点智播为本项赛事提供了全方位的信号制作服务与传输保障，特别地打造了全远程转播制作新模式，实现了高效、轻量化的现场部署..."
            },
            {
              coverImage: newsTwo,
              msg: " “水井坊”最强乒团·2022中国，最美大国",
              recommend:
                " 奇点智播为本项赛事提供了全方位的信号制作服务与传输保障，特别地打造了全远程转播制作新模式，实现了高效、轻量化的现场部署..."
            },
            {
              year: "2023",
              mouth: "03-10",
              title: "陈露国际冰场【智慧冰场】服务",
              introduction:
                "奇点智播【智慧冰场】服务方案在冰场建立多角度多区域的视频数据采集摄像头，在平时教学训练过程中，采集收录学员的花样滑冰动作..."
            },
            {
              year: "2023",
              mouth: "03-10",
              title: " 基于有线电视网的8K足球赛事端到端转播方案研究与试验测试",
              introduction:
                "2022年9月，《基于有线电视网的8K足球赛事端到端转播方案研究与试验测试》征入国家广播电视总局、工业和信息化部的超高清视频典型应用案例名单"
            },
            {
              year: "2023",
              mouth: "03-10",
              title: "基于有线电视网的8K足球赛事端到端转播方案研究与试验测试",
              introduction:
                "2022年9月，《基于有线电视网的8K足球赛事端到端转播方案研究与试验测试》征入国家广播电视总局、工业和信息化部的超高清视频典型应用案例名"
            }
          ]
        },
        {
          headline: "公司资讯",
          children: [
            {
              coverImage: newsOne,
              msg: " “水井坊”最强乒团·2022中国，最美大国",
              recommend:
                " 奇点智播为本项赛事提供了全方位的信号制作服务与传输保障，特别地打造了全远程转播制作新模式，实现了高效、轻量化的现场部署..."
            },
            {
              coverImage: newsTwo,
              msg: " “水井坊”最强乒团·2022中国，最美大国",
              recommend:
                " 奇点智播为本项赛事提供了全方位的信号制作服务与传输保障，特别地打造了全远程转播制作新模式，实现了高效、轻量化的现场部署..."
            },
            {
              year: "2023",
              mouth: "03-10",
              title: "陈露国际冰场【智慧冰场】服务",
              introduction:
                "奇点智播【智慧冰场】服务方案在冰场建立多角度多区域的视频数据采集摄像头，在平时教学训练过程中，采集收录学员的花样滑冰动作..."
            },
            {
              year: "2023",
              mouth: "03-10",
              title: " 基于有线电视网的8K足球赛事端到端转播方案研究与试验测试",
              introduction:
                "2022年9月，《基于有线电视网的8K足球赛事端到端转播方案研究与试验测试》征入国家广播电视总局、工业和信息化部的超高清视频典型应用案例名单"
            },
            {
              year: "2023",
              mouth: "03-10",
              title: "基于有线电视网的8K足球赛事端到端转播方案研究与试验测试",
              introduction:
                "2022年9月，《基于有线电视网的8K足球赛事端到端转播方案研究与试验测试》征入国家广播电视总局、工业和信息化部的超高清视频典型应用案例名"
            }
          ]
        }
      ]
    };
  },
  methods: {
    changeNews(index) {
      this.NewsIndex = index;
    }
  }
};
</script>
<style lang="less" scoped>
@import "./news-information.less";
</style>



// WEBPACK FOOTER //
// src/views/home/components/news-information/news-information.vue